/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ApproveRouteImport } from './routes/approve'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as CloudRouteImport } from './routes/cloud'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as RecordingsRouteImport } from './routes/recordings'
import { Route as RulesRouteImport } from './routes/rules'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApproveRoute = ApproveRouteImport.update({
  id: '/approve',
  path: '/approve',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const CloudRoute = CloudRouteImport.update({
  id: '/cloud',
  path: '/cloud',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordingsRoute = RecordingsRouteImport.update({
  id: '/recordings',
  path: '/recordings',
  getParentRoute: () => rootRouteImport,
} as any)
const RulesRoute = RulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/approve': typeof ApproveRoute
  '/audit': typeof AuditRoute
  '/cloud': typeof CloudRoute
  '/connect': typeof ConnectRoute
  '/recordings': typeof RecordingsRoute
  '/rules': typeof RulesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/approve': typeof ApproveRoute
  '/audit': typeof AuditRoute
  '/cloud': typeof CloudRoute
  '/connect': typeof ConnectRoute
  '/recordings': typeof RecordingsRoute
  '/rules': typeof RulesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/approve': typeof ApproveRoute
  '/audit': typeof AuditRoute
  '/cloud': typeof CloudRoute
  '/connect': typeof ConnectRoute
  '/recordings': typeof RecordingsRoute
  '/rules': typeof RulesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/approve'
    | '/audit'
    | '/cloud'
    | '/connect'
    | '/recordings'
    | '/rules'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/approve'
    | '/audit'
    | '/cloud'
    | '/connect'
    | '/recordings'
    | '/rules'
  id:
    | '__root__'
    | '/'
    | '/approve'
    | '/audit'
    | '/cloud'
    | '/connect'
    | '/recordings'
    | '/rules'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ApproveRoute: typeof ApproveRoute
  AuditRoute: typeof AuditRoute
  CloudRoute: typeof CloudRoute
  ConnectRoute: typeof ConnectRoute
  RecordingsRoute: typeof RecordingsRoute
  RulesRoute: typeof RulesRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approve': {
      id: '/approve'
      path: '/approve'
      fullPath: '/approve'
      preLoaderRoute: typeof ApproveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cloud': {
      id: '/cloud'
      path: '/cloud'
      fullPath: '/cloud'
      preLoaderRoute: typeof CloudRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recordings': {
      id: '/recordings'
      path: '/recordings'
      fullPath: '/recordings'
      preLoaderRoute: typeof RecordingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rules': {
      id: '/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof RulesRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ApproveRoute: ApproveRoute,
  AuditRoute: AuditRoute,
  CloudRoute: CloudRoute,
  ConnectRoute: ConnectRoute,
  RecordingsRoute: RecordingsRoute,
  RulesRoute: RulesRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
